<div class="ml-0 flex h-10 w-full items-center gap-x-1 bg-white px-2 pr-4 text-black caret-black" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="searchResultsOpen.set(true)">
	<mat-icon class="flex cursor-pointer items-center justify-center self-center text-gray-400">search</mat-icon>
	<input #searchInput [placeholder]="searchPlaceholder()" class="flex-1 border-none text-base font-normal tracking-tight focus-visible:outline-none" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)">
	@if (showHotkey()) {
		<div class="rounded-sm border border-solid bg-slate-100 px-2 py-1 text-sm text-gray-400">{{isMac ? '&#8984; + K' : 'CTRL + K'}}</div>
	}
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="searchResultsOpen()" [cdkConnectedOverlayMatchWidth]="true" (detach)="searchResultsOpen.set(false)">
	<div class="max-h-80 w-full overflow-y-auto rounded-b-md border-gray-300 bg-white shadow-md" [class.border]="emptySearch() || searchResults().length" (clickOutside)="searchResultsOpen.set(false)">
		@if (loading()) {
			@for(item of [1,2,3]; track item; let last = $last;) {
				<div class="flex h-18 w-full cursor-pointer gap-4 border-slate-300 p-4" [class.border-b]="!last">
					<div class="size-10 animate-pulse rounded-sm bg-slate-200"></div>
					<div class="flex flex-1 flex-col justify-between">
						<div class="h-4 w-3/4 animate-pulse rounded bg-slate-200"></div>
						<div class="h-4 w-1/2 animate-pulse rounded bg-slate-200"></div>
					</div>
				</div>
			}
		} @else if (emptySearch()) {
			<div #searchResult>
				<ng-container *ngTemplateOutlet="notFound"></ng-container>
			</div>
		} @else {
			@for (patient of searchResults(); track patient.patientId; let last = $last; let index = $index) {
				<div #searchResult (click)="searchItemSelect(patient.patientId)" class="flex h-18 w-full cursor-pointer gap-4 border-slate-300 p-4 hover:bg-slate-50" [class.border-b]="!last || noExactMatches()" [class.bg-slate-50]="index === searchSelectedIndex()">
					<img class="h-full" [src]="patient.profileImageUrl">
					<div class="flex flex-col justify-between">
						<div class="truncate leading-none">{{patient.fullName}}</div>
						<div class="text-sm text-gray-500">DOB: {{patient.birthdate | date : 'mediumDate'}}</div>
					</div>
				</div>
			}
			@if (noExactMatches()) {
				<div #searchResult>
					<ng-container *ngTemplateOutlet="notFound"></ng-container>
				</div>
			}
		}
	</div>
</ng-template>
<ng-template #notFound>
	<div class="flex w-full gap-4 border-slate-300 p-4 hover:bg-slate-50" [class.bg-slate-50]="noSearchResultsSelected()">
		<div class="flex flex-col justify-center">
			<div class="text-sm text-gray-500">We couldn't find an exact match for your search.
				@if(allowCreate()) {
					Would you like to <a class="cursor-pointer text-blue-400 hover:underline" (click)="patientCreationRequested.emit({ searchText: searchText(), addMode: 'new' }); clearSearch()">create a new patient</a>

					@if(allowImport()) { or <a class="cursor-pointer text-blue-400 hover:underline" (click)="patientCreationRequested.emit({ searchText: searchText(), addMode: 'existing' }); clearSearch()">import from PointClickCare</a>}?
				}
				</div>
		</div>
	</div>
</ng-template>
